module.exports = __webpack_public_path__ + "static/media/starIcon.42db8cc9.svg";